export default defineNuxtPlugin((nuxtApp) => {
    const runtimeConfig = useRuntimeConfig()

    return
	const { data, pending, refresh, error } = useFetch(useCountryPath('/cart/create'), {
        method: 'post'
    })
})